module.exports = __webpack_public_path__ + "img/feature-13.b9cfa866.png";